import PersonalInformation from './PersonalInformation.router';
import PersonalInformationRoutes from './PersonalInformation.routes';

export { PersonalInformationRoutes };

export default PersonalInformation;
